module.exports = __webpack_public_path__ + "img/3.78401f2c.jpg";